import { render, staticRenderFns } from "./StatisticSection.vue?vue&type=template&id=449a9cf0&scoped=true"
import script from "./StatisticSection.vue?vue&type=script&lang=js"
export * from "./StatisticSection.vue?vue&type=script&lang=js"
import style0 from "./StatisticSection.vue?vue&type=style&index=0&id=449a9cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a9cf0",
  null
  
)

export default component.exports